import { current } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'universal-cookie'

const initialState = {
    campaigns: [],
    campaignReport: [],
    currentCampaign: {
        contacts:[]
    }

};

// Action Types
const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN';
const GET_CAMPAIGN_REPORT = 'GET_CAMPAIGN_REPORT';
const SEND_CAMPAIGN = 'SEND_CAMPAIGN';

// Reducer
export default function CampaignReducer(state = initialState, action) {
    switch (action.type) {
        case GET_CAMPAIGNS:
            return { ...state, campaigns: action.payload };
        case SEND_CAMPAIGN:
            return { ...state, campaigns: [...state.campaigns, action.payload] };
        case GET_CAMPAIGN_REPORT:
            return { ...state, campaignReport: action.payload };
        case SET_CURRENT_CAMPAIGN:
            return { ...state, currentCampaign: action.payload };
        default:
            return state;
    }
}

// Action Creators
export const SetCampaigns = (campaigns) => ({
    type: GET_CAMPAIGNS,
    payload: campaigns,
});

export const AddCampaign = (campaign) => ({
    type: SEND_CAMPAIGN,
    payload: campaign,
});

export const SetCampaignsReport = (campaignsReport) => ({
    type: GET_CAMPAIGN_REPORT,
    payload: campaignsReport,
});

export const SetCurrentCampaign = (campaign) => ({
    type: SET_CURRENT_CAMPAIGN,
    payload: campaign,
});

// API Integration Functions
export const fetchFullCampaignsFromAPI = (id) => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/Campaign/GetAll/'+id);
        const data = response.data;
        dispatch(SetCampaignsReport(data));
    } catch (error) {
        console.error('Error fetching campaigns:', error);
    }
};

export const fetchCampaignsFromAPI = (id) => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/Campaign/GetSimple/'+id);
        const data = response.data;
        dispatch(SetCampaigns(data));
    } catch (error) {
        console.error('Error fetching campaigns:', error);
    }
};

export const readCampaignReportAPI = (id) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const response = await axios.get(`${window.API_BASE_URL}/Campaign/Report/${id}`, {
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` }
        });
        const data = response.data;
        dispatch(SetCurrentCampaign(data));
    } catch (error) {
        console.error('Error fetching campaign by ID:', error);
    }
};

export const downloadCampaignReportAPI = (id, fileName = `CampaignReport_${id}.xlsx`) => async () => {
    try {
        const cookies = new Cookies();
        const response = await axios.get(`${window.API_BASE_URL}/Campaign/Report/${id}/Download`, {
            headers: { Authorization: `Bearer ${cookies.get('token')}` },
            responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading campaign report:', error);
    }
};


export const sendCampaignAPI = (campaign, file) => async (dispatch) => {
    try {
        const formData = new FormData();

        formData.append('file', file); 
        formData.append('TemplateId', campaign.template); // Asegúrate de que las keys coincidan con tu objeto campaign
        formData.append('Name', campaign.name);
        formData.append('Description', campaign.description);

        const response = await axios.post(window.API_BASE_URL + '/Campaign/Send', formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        const data = response.data;
        if (data) {
            dispatch(AddCampaign(data));
        } else {
            // fallback: refresh list
            dispatch(fetchCampaignsFromAPI());
        }
    } catch (error) {
        console.error('Error sending campaign:', error);
    }
};

// Acción para descargar el formato de campaña desde API (sin parámetros)
export const downloadCampaignFormat = (idTemplate, templateName) => async () => {
    try {
        const cookies = new Cookies();
        const response = await axios.get(
            `${window.API_BASE_URL}/Campaign/DownloadFormat/${idTemplate}`,
            {
                headers: {
                    Authorization: `Bearer ${cookies.get('token')}`,
                },
                responseType: 'blob', // importante para manejar archivo
            }
        );

        // Crear enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        // Nombre de archivo sugerido
        link.setAttribute('download', `${templateName}_Campaign.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

    } catch (error) {
        console.error('Error descargando formato de campaña:', error);
    }
};


